// extracted by mini-css-extract-plugin
module.exports = {"settingsWrapper":"ClinicAccountSettingsLayout_settingsWrapper__gD0Rq","settingsSection":"ClinicAccountSettingsLayout_settingsSection__3n0Dj"};